import { render, staticRenderFns } from "./SubtasksCount.vue?vue&type=template&id=08561f6d&scoped=true&"
import script from "./SubtasksCount.vue?vue&type=script&lang=js&"
export * from "./SubtasksCount.vue?vue&type=script&lang=js&"
import style0 from "./SubtasksCount.vue?vue&type=style&index=0&id=08561f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08561f6d",
  null
  
)

export default component.exports